import ElementCreator from './ElementCreator';
import * as StyleFunctions from '../utilities/StyleFunctions';

export default function cleanPage(ref, rawContents, screenPath, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, upwardInfo, onClickItemChangeSelection, interactionFn, organicChanges){
  var current = ref.current;
  var childNodes = current.childNodes;
  var nosChildnodes = childNodes.length;
  for (var i = 0; i < nosChildnodes; i++){
    current.removeChild(childNodes[0]);
  }

  var overall1 = StyleFunctions.marchDownToCleanUpH(rawContents);
  actDoRawContents(current, overall1);

  function compareStyles(a,b){
    var aKeys = Object.keys(a.s);
    var bKeys = Object.keys(b.s);
    if (aKeys.length === bKeys.length){
      for (var i = 0; i < aKeys.length; i++){
        var thisAKey = aKeys[i];
        if (a.s[thisAKey] === b.s[thisAKey]){
        }else{
          return false;
        }
      }
      return true;
    }
    return false;
  }

  function actDoRawContents(current, rawContents){
    // var gotIssue = false;
    var cleanUp = [];
    rawContents.forEach((aRawContent, index)=>{
      if (aRawContent.t === 't'){
        if (cleanUp.length > 0){
          var lastT = cleanUp[cleanUp.length - 1];
          if (lastT.t === 't'){
            var comparedT = compareStyles(lastT, aRawContent);
            if (comparedT){
              lastT.v = lastT.v + aRawContent.v;
            }else{
              cleanUp.push(JSON.parse(JSON.stringify(aRawContent)));
            }
          }
        }else{
          cleanUp.push(JSON.parse(JSON.stringify(aRawContent)));
        }
      }else if (aRawContent.t === 'tb'){
        if (cleanUp.length > 0){
          var last = cleanUp[cleanUp.length - 1];
          if (last.t === 'tb'){
            var compared = compareStyles(last, aRawContent);
            if (compared){
              last.v = last.v.concat(aRawContent.v);
            }else{
              cleanUp.push(JSON.parse(JSON.stringify(aRawContent)));
            }
          }else{
            cleanUp.push(JSON.parse(JSON.stringify(aRawContent)));            
          }
        }else{
          cleanUp.push(JSON.parse(JSON.stringify(aRawContent)));
        }
      }else{
        cleanUp.push(JSON.parse(JSON.stringify(aRawContent)));
      }
    })

    for (var i = 0; i < cleanUp.length; i++){
      var aContent = cleanUp[i];
      if (aContent.t === 'br'){
        current.appendChild(document.createElement('br'));
      }else if (aContent.t === 't' || aContent.t === 'tb'){
        if (aContent.t === 't'){
          console.log(aContent);
        }
        var eleSet1 = ElementCreator(aContent, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, upwardInfo, onClickItemChangeSelection, screenPath, interactionFn, organicChanges);
        current.appendChild(eleSet1);
      }else if (aContent.t === 'h'){
        var title = 'div';
        if (aContent.n){
          title = aContent.n;
        }
        var p1 = document.createElement(title);
        actDoRawContents(p1, aContent.v)
        current.appendChild(p1);
      }else if (aContent.t === 'a'){
        var ele = ElementCreator(aContent, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, upwardInfo, onClickItemChangeSelection, screenPath, interactionFn, organicChanges);
        current.appendChild(ele);
      }
    }

    }

  }

